module.exports = __webpack_public_path__ + "static/media/footer-logo-blue.87be75d5.png";